<template>
    <div class="container">
        <div class="d-flex flex-wrap" v-if="showForm" style="gap: 2.125rem">
            <div style="flex: 1 1 228px">
                <div class="label-form-div">
                    <div class="form-label-heading mb-3 pb-1">Size</div>
                    <div class="form-check mb-2" v-for="(sizeOption, sizeKey) in sizeInfo">
                        <input class="form-check-input" type="radio" :id="'size_radio_'+sizeKey" :value="sizeKey" v-model="selected_size">
                        <label class="form-check-label" :for="'size_radio_'+sizeKey">
                            {{formatSizeString(sizeKey)}}
                        </label>
                    </div>
                </div>
            </div>
            <div style="flex: 1 1 272px">
                <div class="label-form-div">
                    <div class="form-label-heading mb-3 pb-1">Quantity</div>
                    <div class="form-check mb-2" v-for="(amountOption, amountKey) in sizeInfo[selected_size]">
                        <input class="form-check-input" type="radio" :id="'amount_radio_'+amountKey" :value="amountKey" v-model="selected_amount">
                        <label class="form-check-label d-flex justify-content-between flex-wrap gap-2" :for="'amount_radio_'+amountKey">
                            {{amountKey}} Pcs  <span v-html="amountOption.formatted_price"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div style="flex: 1 1 534px">
                <div class="label-form-div">
                    <div class="form-label-heading mb-3 pb-1">Add file</div>
                    <div v-if="filesToggle">
                        <file-upload
                            name="file"
                            :media-options="mediaOptions"
                            @files="updateFiles"
                            @onError="notifyError"
                            ref="fileUpload"
                            multiple
                        ></file-upload>

                        <div class="mt-3" style="color: red;" v-if="errorMessage !== ''" v-html="errorMessage"></div>
                    </div>
                </div>

                <div v-if="addToCartEnabled" class="mt-3">
                    <button type="button" class="btn btn-primary w-100 text-uppercase" @click="addToCart" :disabled="loading">Add to cart</button>
                </div>

                <div class="didnt-find-message mt-3 pt-2 text-center text-sm-left">
                    Don’t see a size or quantity listed? <a :href="route('contact.create')">Contact us</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FileUpload from "./FileUpload";
    import ProductCardMixin from "../../mixins/ProductCardMixin";
    import vue from 'vue';
    import {formatPrice, formatSizeString} from "../../functions";

    export default {
        name: "LabelForm",
        components: {FileUpload},
        props: ['sizeInfo', 'mediaOptions', 'labelId'],
        mixins: [
            ProductCardMixin
        ],
        data() {
            return {
                showForm: false,
                selected_size: null,
                selected_amount: null,
                sizeKeys: [],
                errorMessage: '',
                files: [],
                filesToggle: true,
                loading:false,
            };
        },
        watch: {
            selected_size(newSize, oldSize) {
                this.selectAmount(this.selected_amount);
            }
        },
        mounted() {
            this.sizeKeys = Object.keys(this.sizeInfo);
            this.selected_size = this.sizeKeys[0] ? this.sizeKeys[0] : null;
            if (this.selected_size !== null) {
                this.selectAmount();
            }
            this.showForm = this.sizeKeys.length > 0;
        },
        computed: {
            addToCartEnabled() {
                let result = false;
                if (this.files.length > 0) {
                    result = true;
                    if (this.files[0].loading) {
                        result = false;
                    }
                }
                if (this.selected_amount === null || this.selected_size === null) {
                    result = false;
                }
                return result;
            }
        },
        methods: {
            updateFiles(data) {
                this.files = data;
            },
            notifyError(message) {
                this.errorMessage = message;
            },
            selectAmount(preferredAmount = "") {
                let newAmount = null;
                let amountKeys = Object.keys(this.sizeInfo[this.selected_size]);
                amountKeys.forEach(amountKey => {
                    if (preferredAmount === amountKey) {
                        newAmount = amountKey;
                    }
                })
                if (newAmount !== null) {
                    this.selected_amount = newAmount;
                } else {
                    this.selected_amount = amountKeys[0] ? amountKeys[0] : null;
                }
            },
            addToCart() {
                let app = this;
                let fileData = [];
                app.loading = true;
                this.files.forEach(file => {
                    fileData.push({
                        name: file.file_name,
                        data: file.encoded_file,
                    });
                });
                this.addToCartLabelPicker(
                    fileData,
                    app.labelId,
                    app.sizeInfo[app.selected_size][app.selected_amount].id,
                ).then(() => {
                    app.filesToggle = false;
                    vue.nextTick(() => {
                        app.filesToggle = true;
                        app.loading = false;
                    });
                }).catch(() => {
                    app.loading = false;
                });
            },
            formatPrice(price) {
                return formatPrice(price);
            },
            formatSizeString(dimension) {
                return formatSizeString(dimension);
            }
        }
    }
</script>

<style scoped>

</style>
